import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

if (process.env.VUE_APP_MODE === "development") {
  Vue.config.devtools = true;
} else {
  Vue.config.devtools = false;
  Vue.config.performance = false;
  Vue.config.silent = true;
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
